import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  select: {
    marginBottom: 0
  }
}));

export default useStyles;
